import React from 'react';
import {ButtonsGroup, PaperStyled} from "../../../index.styles";
import {Field, FieldsWrapper} from "../index.styles";
import {useSelector} from "react-redux";
import {selectorPermissions} from "../../../../../../../redux/selectors";
import concatAddress from "../../../../../../../utils/concat-address";
import {EditWrapper} from "../../id-details/index.styles";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import Button from "../../control/button/button";
import {EButtonType} from "../../control/button/button.types";
import {
  baasEmploymentTypeFull,
  employmentTypeFull,
  IEKYCDetails,
  TUsersDetail
} from "../../../../../../../types/entities/users";

type TViewProfileInfo = {
  setMode: (mode: string) => void;
  data: IEKYCDetails;
  updatedData: IEKYCDetails;
  userData?: TUsersDetail;
  setNextPage: () => void;
  handleSkip: () => void;
  disableEdit: boolean;
};

const ViewPersonalInfo = ({
  setMode,
  data,
  updatedData,
  userData,
  handleSkip,
  disableEdit,
}: TViewProfileInfo) => {
  const permissions = useSelector(selectorPermissions);

  const checkIfUpdated = (field: string) => {
    if (!data[field]) return updatedData[field]
    const isUpdated = updatedData[field] !== data[field];
    if (isUpdated) return updatedData[field];
    return data[field];
  }

  const checkIfEmploymentIsInBaasFormat = (field: string) => {
    if (!data[field]) return baasEmploymentTypeFull[checkIfUpdated('employmentType')];
    const dataStartsWithOccupation = data[field].startsWith('occupation') || updatedData[field].startsWith('occupation');
    if (dataStartsWithOccupation) {
      return employmentTypeFull[checkIfUpdated('employmentType')];
    } else {
      return baasEmploymentTypeFull[checkIfUpdated('employmentType')];
    }
  }
  const nameForEmptyEkycData = userData?.lastName ? `${userData?.firstName} ${userData?.lastName}` : `${userData?.firstName}`;

  return (
    <React.Fragment>
      <PaperStyled>
        { !disableEdit && (
          <EditWrapper>
            <Tooltip
              title={
                  permissions?.userEKYCEdit
                      ? ('Edit')
                      : (
                          "You don't have permission to edit customer information"
                      )
              }
            >
              <div>
                <IconButton
                  disabled={!permissions?.userEKYCEdit}
                  onClick={() => setMode('edit')}
                >
                  <EditIcon />
                </IconButton>
              </div>
            </Tooltip>
          </EditWrapper>
        )}

        <FieldsWrapper>
          {
            // Check if ekyc data / updatedData isn't empty
            (data?.name) || (updatedData?.name) ? (
                <>
                  <Field>
                    <span className="title">Name:</span>
                    <span className="value">{checkIfUpdated('name') || '—'}</span>
                  </Field>
                  <Field>
                    <span className="title">Place of Birth:</span>
                    <span className="value">{checkIfUpdated('placeOfBirth') || '—'}</span>
                  </Field>
                  <Field>
                    <span className="title">Date of birth:</span>
                    <span className="value">{checkIfUpdated('dateOfBirth') || '—'}</span>
                  </Field>
                  <Field>
                    <span className="title">Marital Status:</span>
                    <span className="value">{checkIfUpdated('maritalStatus') || '—'}</span>
                  </Field>
                  <Field>
                    <span className="title">Gender:</span>
                    <span className="value">{checkIfUpdated('gender') || '—'}</span>
                  </Field>
                  <Field>
                    <span className="title">Nationality:</span>
                    <span className="value">{checkIfUpdated('nationality') || '—'}</span>
                  </Field>
                  <Field>
                    <span className="title">KTP Address:</span>
                    <span className="value">{concatAddress(checkIfUpdated('idAddress')) || '—'}</span>
                  </Field>
                  <Field>
                    <span className="title">Residential Address:</span>
                    <span className="value">{concatAddress(checkIfUpdated('residentialAddress')) || '—'}</span>
                  </Field>
                  <Field>
                    <span className="title">Employment Type:</span>
                    <span className="value">{checkIfEmploymentIsInBaasFormat('employmentType')}</span>
                  </Field>
                </>
            ) : (
              // If ekyc data is empty, shows the name only
              <Field>
                <span className="title">Name:</span>
                <span className="value">{nameForEmptyEkycData || '—'}</span>
              </Field>
            )
          }
        </FieldsWrapper>
      </PaperStyled>

      <ButtonsGroup>
        <Button styleType={EButtonType.Outline} onClick={handleSkip}>
          {'Next'} <NavigateNextIcon />
        </Button>
      </ButtonsGroup>

    </React.Fragment>
  );
};

export default ViewPersonalInfo;
